import {client, handleDataOrError} from '@freckle/educator-entities/ts/curricula-api-client'
import {components} from '@freckle/educator-entities/ts/curricula-api/generated-client'

export type DecodableInfoT = components['schemas']['Decodable']

export const fetchDecodableInfos = (): Promise<Array<DecodableInfoT>> =>
  client.GET('/decodables.json').then(handleDataOrError)
